// Business contact for orders. Update here to change everywhere.
export const ORDER_WHATSAPP = "40748888148"; // no + prefix, digits only for wa.me
export const ORDER_WHATSAPP_DISPLAY = "+40 748 888 148";
export const ORDER_EMAIL = "mg.brandstock24@gmail.com";

const money = (n) =>
  Number(n).toLocaleString("ro-RO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const buildOrderMessage = (items, totalPrice) => {
  const lines = ["Bună ziua! Doresc să comand următoarele produse:", ""];
  items.forEach((it, idx) => {
    const parts = [`${idx + 1}. ${it.name}`];
    const meta = [];
    if (it.size) meta.push(it.size);
    if (it.pack) meta.push(it.pack);
    if (meta.length) parts.push(`(${meta.join(" · ")})`);
    parts.push(`— ${it.qty} buc`);
    if (it.price != null) {
      parts.push(`× ${money(it.price)} lei = ${money(it.price * it.qty)} lei`);
    }
    lines.push(parts.join(" "));
  });
  lines.push("");
  if (totalPrice > 0) {
    lines.push(`Total estimativ: ${money(totalPrice)} lei`);
    lines.push("");
  }
  lines.push("Vă mulțumesc!");
  return lines.join("\n");
};

export const openWhatsAppOrder = (items, totalPrice) => {
  const msg = buildOrderMessage(items, totalPrice);
  const url = `https://wa.me/${ORDER_WHATSAPP}?text=${encodeURIComponent(msg)}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

export const openEmailOrder = (items, totalPrice) => {
  const subject = `Comandă nouă — Produse Alimentare En Gross (${items.length} produse)`;
  const body = buildOrderMessage(items, totalPrice);
  const url = `mailto:${ORDER_EMAIL}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
  window.location.href = url;
};
